<div class="wrap">
  <app-booking
    *ngIf="data"
    [booking]="data.booking"
    [currentUser]="data.currentUser"
    (onDialogClose)="dialogRef.close()"></app-booking>
</div>
